<template>
  <div class="grid-header px-2 my-0 d-flex flex-sm-column flex-md-row">
    <div class="my-sm-1 my-md-0">
      <div class="d-flex align-items-center w-100 px-2">
        <div class="mr-2">
          <router-link :to="`/configuration`">
            <b-button class="btn__icon btn__icon--primary px-2">
              <i
                class="far fa-arrow-left"
                aria-hidden="true"
              />
            </b-button>
          </router-link>
        </div>
        <div class="d-flex align-items-center w-100">
          <span class="grid-header__title font-weight--medium">
            <i
              :class="`${sectionIcon} mr-2`"
              aria-hidden="true"
            />
            {{ sectionTitle }}
          </span>
          <div class="truncate">
            <small
              v-if="sectionSubtitle"
              class="ml-3"
            >{{ sectionSubtitle }}</small>
          </div>
          <div
            v-if="localConfiguration"
            class="grid-header__title font-weight--light d-flex align-items-center"
          >
            <span class="alt-color mx-3"><i
              class="far fa-chevron-right"
              aria-hidden="true"
            /></span>
            <span class="alt-color">{{ laboratoryName }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-end mr-2 mb-sm-1 mb-md-0">
      <grid-display-options
        v-if="showDisplayOptions"
        :ui-component="uiComponentConfiguration"
        @changedPageSize="$emit('changedPageSize', $event)"
        @changedMode="$emit('changedMode', $event)"
      />
      <slot />
    </div>
  </div>
</template>

<script>
import { StoreUtils } from '@/shared/util/store-utils'
import GridDisplayOptions from '@/components/GridDisplayOptions'

export default {
    name: 'ConfigurationSectionHeader',
    components: {
        GridDisplayOptions
    },
    props: {
        sectionTitle: String,
        sectionIcon: String,
        sectionSubtitle: String,
        shortcutsButton: { type: Boolean, default: true },
        localConfiguration: { type: Boolean, default: false },
        showDisplayOptions: { type: Boolean, default: true }
    },
    data() {
        return {
            uiComponentConfiguration: 'uicomponent.configuration.grid'
        }
    },
    computed: {
        laboratoryName() {
            return StoreUtils.selectedLaboratoryConfiguration?.laboratory.labName
        }
    }
}
</script>

<style lang="scss">
    .configuration-section-header .configuration-context span:first-child {
        color: vt-color(alt-primary);
        font-size: font-size(big);
        margin: 0 12px;
    }
    .configuration-section-header .configuration-context span {
        color: vt-color(alt-primary);
    }
    .configuration-section-header .truncate {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
